import styled from "styled-components";
import {Card} from "@mui/material";

export const DashboardContainer = styled.div`
  padding: 20px;
`;

export const MobileCard = styled(Card)`
  margin-bottom: 20px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopTable = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;
